<ng-form #stepForm="ngForm">
    <!-- shipping methods -->
    <div>
        @switch (noShippingNeeded) {
        <!-- virtual order -->
        @case (true) {
        <p>{{'No shipping information required' | translate}}</p>
        }
        <!-- regular order -->
        @case (false) {
        <div class="delivery-options m-t">
            <!-- no methods found notice -->
            @if (!methods.length && !message) {
            <div [innerHtml]="info | translate"
                 class="left p2"></div>
            }
            <!-- message -->
            @if (message) {
            <div class="p-b-3 left p2"
                 [innerHtml]="message | translate"></div>
            }
            <!-- methods list -->
            <radio-group name="shippingMethod"
                         [value]="data.method"
                         [(ngModel)]="data.method">
                @for (method of methods; track method.code; let isFirst = $first) {
                <div class="bg-col-51 p-a p-t-3 left"
                     [ngClass]="{'m-t-3-m m-t-3-s m-t': !isFirst, 'bg-col-53': data.method === method.code}">
                    <radio class="w-12 p-l-9 p-l-8-m p-r-14-s pos-relative"
                           [value]="method.code">
                        <div class="flex flex-wrap m-r-15">
                            <p class="p1 p-r-2 inline">{{method.title}}</p>
                            @if (getSurchargeValue(method)) {
                            <div>
                                <p class="p1 inline">(incl.</p>&nbsp;
                                <price class="p1"
                                       [value]="getSurchargeValue(method)"
                                       [precision]="2"></price>&nbsp;
                                <p class="p1 p-r-2 inline"> surcharges) </p>
                            </div>
                            }
                        </div>
                        @if (method.description) {
                        <div class="m-t-1 p2"
                             [innerHTML]="method.description | translate"></div>
                        }
                        @if (method.lead_time) {
                        <div class="m-t-1 p2"
                             [innerHTML]="method.lead_time"></div>
                        }
                        @if (canDisplayScurriEstimatedDelivery && getEstimatedDate(method)) {
                        <p class="m-t-1 p2">{{getEstimatedDate(method)}}</p>
                        }
                        @if (!hasFreeShipping(method.price)) {
                        <price class="s2 pos-absolute top-0 right-0"
                               [value]="method.price"
                               [precision]="2"></price>
                        }
                        @if (hasFreeShipping(method.price)) {
                        <p class="s2 pos-absolute top-0 right-0">{{'Free' | translate}}</p>
                        }
                    </radio>
                </div>
                }
            </radio-group>
            <input-wrap class="block m-t-6 m-t-9-m m-t-9-s"
                        *ifTradeStore>
                <textarea class="textarea p-b-6-m p-b-5-s p-t-7-s"
                          style="resize:none;"
                          name="delivery_note"
                          [(ngModel)]="customData.delivery_note"
                          [muiInput]="'Order Comments' | translate"></textarea>
            </input-wrap>
            <input-wrap class="left"
                        [messages]="methods.length ? undefined : { required:'No delivery options found. Please double check your delivery address.' }">
                <input type="hidden"
                       [(ngModel)]="data.method"
                       name="shippingMethod"
                       required>
            </input-wrap>
        </div>
        }
        }
    </div>
</ng-form>
@if (showSurchargeInfo) {
<div>
    <surcharge-info-block [variant]="'checkout'"></surcharge-info-block>
</div>
}
<p class="p2 left"
   [ngClass]="showSurchargeInfo ? 'b-t-x b-t-l b-col-51 p-t-2 m-t-7' : 'm-t-6'"
   *ifNotTradeStore>
    {{'There will be the option to provide special delivery instructions directly to the courier who
    will contact you once they have received your parcel from us.' | translate}}</p>